import { IAudition, ILocation, IProject, IRole, ISound, IUserSummary } from '../../types/global/helper';

export const types = {
    GET_ALL_USERS: 'GET_ALL_USERS',
    GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
    GET_ALL_USERS_FAIL: 'GET_ALL_USERS_FAIL',

    SEND_MESSAGE: 'SEND_MESSAGE',
    SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',
    SEND_MESSAGE_FAIL: 'SEND_MESSAGE_FAIL',

    DELETE_MESSAGE: 'DELETE_MESSAGE',
    DELETE_MESSAGE_SUCCESS: 'DELETE_MESSAGE_SUCCESS',
    DELETE_MESSAGE_FAIL: 'DELETE_MESSAGE_FAIL',

    GET_ALL_MESSAGES: 'GET_ALL_MESSAGES',
    GET_ALL_MESSAGES_SUCCESS: 'GET_ALL_MESSAGES_SUCCESS',
    GET_ALL_MESSAGES_FAIL: 'GET_ALL_MESSAGES_FAIL',

    UPDATE_MESSAGE: 'UPDATE_MESSAGE',
    UPDATE_MESSAGE_SUCCESS: 'UPDATE_MESSAGE_SUCCESS',
    UPDATE_MESSAGE_FAIL: 'UPDATE_MESSAGE_FAIL',

    REACT_TO_MESSAGE: 'REACT_TO_MESSAGE',
    REACT_TO_MESSAGE_SUCCESS: 'REACT_TO_MESSAGE_SUCCESS',
    REACT_TO_MESSAGE_FAIL: 'REACT_TO_MESSAGE_FAIL',

    CONNECT: 'CONNECT',
    DISCONNECT: 'DISCONNECT',

    RETRIEVE_USER_ROOMS: 'RETRIEVE_USER_ROOMS',
    RETRIEVE_USER_ROOMS_SUCCESS: 'RETRIEVE_USER_ROOMS_SUCCESS',
    RETRIEVE_USER_ROOMS_FAIL: 'RETRIEVE_USER_ROOMS_FAIL',
    RETRIEVE_ROOMS: 'RETRIEVE_ROOMS',

    GET_MY_ROOMS: 'GET_MY_ROOMS',
    GET_MY_ROOMS_SUCCESS: 'GET_MY_ROOMS_SUCCESS',
    GET_MY_ROOMS_FAIL: 'GET_MY_ROOMS_FAIL',

    USER_TYPING: 'USER_TYPING',
    USER_STOP_TYPING: 'USER_STOP_TYPING',

    TYPING_STATUS: 'TYPING_STATUS',

    USER_HAS_READ: 'USER_HAS_READ',

    JOIN_ALL_CHAT_ROOMS: 'JOIN_ALL_CHAT_ROOMS',

    SET_ONLINE_STATUS: 'SET_ONLINE_STATUS',

    SET_ONLINE_USERS: 'SET_ONLINE_USERS',

    SET_OFFLINE_USER: 'SET_OFFLINE_USER',

    NEW_CONTENT: 'NEW_CONTENT',
    NEW_CONTENT_AVAILABLE: 'NEW_CONTENT_AVAILABLE',
    SET_NEW_CONTENT: 'SET_NEW_CONTENT',
    RESET_NEW_CONTENT: 'RESET_NEW_CONTENT',

    SET_ROOM_MESSAGES: 'SET_ROOM_MESSAGES',
    SET_ROOM_MESSAGES_SUCCESS: 'SET_ROOM_MESSAGES_SUCCESS',
    SET_ROOM_MESSAGES_FAIL: 'SET_ROOM_MESSAGES_FAIL',

    INITIATE_MESSAGE: 'INITIATE_MESSAGE',
    INITIATE_MESSAGE_SUCCESS: 'INITIATE_MESSAGE_SUCCESS',
    INITIATE_MESSAGE_FAIL: 'INITIATE_MESSAGE_FAIL',

    GET_MESSAGES_FOR_SELECTED_ROOM: 'GET_MESSAGES_FOR_SELECTED_ROOM',

    LEAVE_ROOM: 'LEAVE_ROOM',

    UPDATE_UNREAD_COUNT: 'UPDATE_UNREAD_COUNT',

    SEARCH_ROOMS: 'SEARCH_ROOMS',
    SEARCH_ROOMS_SUCCESS: 'SEARCH_ROOMS_SUCCESS',
    SEARCH_ROOMS_FAIL: 'SEARCH_ROOMS_FAIL',

    // File upload related types
    QUEUE_FILE_UPLOAD: 'QUEUE_FILE_UPLOAD',
    UPLOAD_MESSAGE_FILE: 'UPLOAD_MESSAGE_FILE',
    UPLOAD_MESSAGE_FILE_SUCCESS: 'UPLOAD_MESSAGE_FILE_SUCCESS',
    UPLOAD_MESSAGE_FILE_FAIL: 'UPLOAD_MESSAGE_FILE_FAIL',
};

// --- Type Definitions ---
export type Payload = {
    data: {
        query: {
            user: string;
            withUnreadOnly?: boolean;
            page?: number;
            limit?: number;
        };
    };
};

type Pagination = {
    limit: number;
    page: number;
};

export type JoinChatPayload = {
    roomID: string;
    userID: string;
    pagination?: Pagination;
};

export type JoinAllChatPayload = {
    rooms: Array<string>;
    userID?: string;
};

export type LastMessageRead = {
    user: string;
    message: string;
};

export type ChatRead = {
    roomID: string;
    readBy: Array<string>;
    lastMessageIdRead?: Array<LastMessageRead>;
};

export type TypingStatus = {
    status: 'yes' | 'no';
    roomID: string;
};

export type OnlineStatus = 'online' | 'offline';

export type NewContentType = 'audition' | 'act' | 'talents';

export enum SOCKET_REQUESTS {
    CONNECTION = 'connection',
    SEND_MESSAGE = 'sendMessage',
    GET_ALL_MESAGES = 'getMessages',
    GET_ROOMS = 'getRooms',
    GET_SINGLE_MESSAGE = 'getSingleMessage',
    BROADCAST = 'broadcast',
    DISCONNECT = 'disconnect',
    CONNECT = 'connect',
    MESSAGE = 'messaage',
    NEW_MESSAGE = 'newMessage',
    FAILED_MESSAGE = 'failedMessage',
    RETRIEVE_MESSAGES = 'retrieveMessages',
    RETRIEVE_ROOMS = 'retrieveRooms',
    USER_TYPING = 'userTyping',
    JOIN_ROOM = 'joinRoom',
    LEAVE_ROOM = 'leaveRoom',
    JOIN_ALL_ROOMS = 'joinAllRooms',
    USER_HAS_READ = 'userHasRead',
    ROOM_MESSAGES = 'roomMessages',
    GET_ROOM_MESSAGES = 'getRoomMessages',
    SET_ONLINE_USERS = 'setOnlineUsers',
    SET_OFFLINE_USERS = 'setOfflineUsers',
    ONLINE = 'online',
    OFFLINE = 'offline',
    NEW_CONTENT_AVAILABLE = 'newContentAvailable',
    NEW_CONTENT = 'newContent',
    UNREAD_COUNT_UPDATE = 'unreadCountUpdated',
    EDIT_MESSAGE = 'editMessage',
    MESSAGE_EDITED = 'messageEdited',
    DELETE_MESSAGE = 'deleteMessage',
    MESSAGE_DELETED = 'messageDeleted',
    EDIT_REACTION = 'editReaction',
    LOGOUT = 'logout',
    REACTION_UPDATED = 'reactionUpdated',
    ERROR = 'error',
}

type TUnreadMessageCount = {
    user: string;
    _id?: string;
    count: number;
};

export interface IParticipant {
    user: IUserSummary;
    status: 'online' | 'offline';
    lastSeen: string;
}

export interface IRoom {
    _id: string;
    sender: IUserSummary;
    receiver: IUserSummary[];
    created_at: string;
    created_by: IUserSummary;
    last_message_at: string;
    last_message_read: IMessage[];
    user_has_unread_messages: boolean;
    read_by: string[];
    deleted: false;
    messages: IMessage[];
    /** Determines if a user in the room is typing */
    isUserTyping?: 'yes' | 'no';
    unread_message_count?: TUnreadMessageCount[];
    userTyping?: string[];
}

type IMessageType =
    | 'chat'
    | 'audition_invite'
    | 'application_invite'
    | 'user_invite'
    | 'media_request'
    | 'video_message'
    | 'picture_message'
    | 'sound_message'
    | 'location_message'
    | 'document_message';

export interface IMessageReaction {
    user: string;
    reaction: string;
}
export interface IMessage {
    _id: string;
    room: IRoom;
    message_content: string;
    audition?: IAudition;
    role?: IRole;
    created_at: string;
    createdAt: string;
    updatedAt?: string;
    created_by: IUserSummary;
    received?: boolean;
    media?: IProject[];
    image?: string[];
    audio?: ISound[];
    is_reply?: boolean;
    location?: ILocation;
    document?: string[];
    parent_message?: IMessage;
    message_type?: IMessageType;
    reactions?: IMessageReaction[];
    uniqueSocketID?: string;
    edited?: boolean;
    edited_at?: string;
    deleted?: boolean;
    isLoading?: boolean;
    uploadError?: boolean;
    tempImages?: string[];
    tempDocumentNames?: string[];
    tempProjects?: IProject[];
    tempAudios?: ISound[];
}

export interface IPagination {
    totalCount: number;
    totalPages: number;
    currentPage: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
    results?: number;
    limit: number;
}

export interface IMessageInitialState {
    users: IUserSummary[];
    rooms: IRoom[];
    selectedRoomMessages: IMessage[];
    roomMsgError: any;
    fetchingRoomMsg: boolean;
    fetchingRooms: boolean;
    fetchingMessages: boolean;
    loadingMore?: boolean;
    sendingMessage: boolean;
    gettingMessages: boolean;
    gettingMessagesError: any;
    isUserTyping: 'yes' | 'no';
    newMessage: boolean;
    sendingMsgError: any;
    onlineUsers: Array<IUserSummary>;
    newContentAvailable: boolean;
    newContentType: '' | 'audition' | 'act' | 'talents';
    roomsPagination: IPagination;
    messagesPagination: IPagination;
    searching: boolean;
    searchError: any;
    isSearchActive: boolean;
    searchTerm: string;
    fetchingMoreRooms?: boolean;
    fileUploadQueue?: Array<{
        messageId?: string;
        file: File;
        path: string;
        socketId: string;
        room: string;
    }>;
    participants: IParticipant[];
}

type TMessageType =
    | 'chat'
    | 'audition_invite'
    | 'application_invite'
    | 'user_invite'
    | 'media_request'
    | 'video_message'
    | 'picture_message'
    | 'sound_message'
    | 'location_message'
    | 'document_message';

type TMessageReaction = {
    user: IUserSummary | string;
    reaction: string;
};

export interface IMessagePayload {
    room: string;
    message_content: string;
    created_by: string;
    created_at: string;
    audition?: string;
    createdAt?: string;
    role?: string;
    media?: string[];
    image?: string[];
    audio?: string[];
    is_reply?: boolean;
    location?: ILocation;
    document?: string[];
    parent_message?: string;
    message_type?: TMessageType;
    reactions?: TMessageReaction[];
    /** Allows to track the message once successfull */
    uniqueSocketID?: string;
    userObject?: IUserSummary;
    replyingToObject?: IMessage;
}

export interface IUserTyping {
    status: 'yes' | 'no';
    roomID: string;
    userId: string;
}

export interface IReactToMessage {
    messageId: string;
    /** Single Reaction */
    reaction: string;
    room: string;
    remove?: boolean;
}

export interface IReactToMessageSuccess {
    updatedMessage: IMessage;
    room: string;
    action?: 'removed' | 'updated' | 'added';
}

export interface IUdateMessage {
    messageId: string;
    message_content?: string;
    room: string;
    image?: string[];
    document?: string[];
}

export interface IUpdateMessageSuccess {
    updatedMessage: IMessage;
    currentRoom: IRoom;
}

export interface IDeleteRoomMessage {
    messageId: string;
    room: string;
}

export interface IDeleteRoomMessageSucess {
    messageId: string;
    currentRoom: IRoom;
}

export interface IGetMyRoom {
    page?: number;
    limit?: number;
}

export interface IGetRoomSuccess {
    rooms: IRoom[];
    pagination: IPagination;
}

export interface IUpdateMessage {
    messageId: string;
    payload: Record<string, any>;
}
